module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/review-stars-8c3fd9d5a4fe0ae3cbb0957faeb7dcef.png";